export default () => ({
    open: false,
    menuCloseDelay: 300,
    menuCloseTimeout: null,
    menuLeave() {
        let that = this;
        this.menuCloseTimeout = setTimeout(() => {
            that.menuClose();
        }, this.menuCloseDelay);
    },
    menuClearCloseTimeout() {
        clearTimeout(this.menuCloseTimeout);
    },
    menuClose() {
        this.open = false;
    },
    trigger: {
        ['x-ref']: 'trigger',
        ['x-on:mouseover']() {
            this.open = true;
        },
        ['x-on:mouseleave']() {
            this.menuLeave();
        },
        ['x-bind:aria-expanded']() {
            return this.open;
        },
        ['aria-haspopup']: 'menu',
    },
    subMenu: {
        ['x-show']() {
            return this.open;
        },
        ['x-on:mouseover']() {
            return this.menuClearCloseTimeout();
        },
        ['x-on:mouseleave']() {
            return this.menuLeave();
        },
        ['x-on:click']() {
            return (this.open = false);
        },
    },
});